import { useFieldArray } from 'react-hook-form'
import SchoolRecordInput from './SchoolRecordInput';

const VolunteerTable = ({ register, control, isRead = false }) => {

    const {
        fields: volunteer_g10_first_fields,
        append: volunteer_g10_first_append,
        remove: volunteer_g10_first_remove,
        move: volunteer_g10_first_move
    } = useFieldArray({
        control,
        name: 'volunteer.g10.first',
    });

    const {
        fields: volunteer_g10_second_fields,
        append: volunteer_g10_second_append,
        remove: volunteer_g10_second_remove,
        move: volunteer_g10_second_move
    } = useFieldArray({
        control,
        name: 'volunteer.g10.second',
    });

    const {
        fields: volunteer_g11_first_fields,
        append: volunteer_g11_first_append,
        remove: volunteer_g11_first_remove,
        move: volunteer_g11_first_move
    } = useFieldArray({
        control,
        name: 'volunteer.g11.first',
    });
    const {
        fields: volunteer_g11_second_fields,
        append: volunteer_g11_second_append,
        remove: volunteer_g11_second_remove,
        move: volunteer_g11_second_move
    } = useFieldArray({
        control,
        name: 'volunteer.g11.second',
    });

    const {
        fields: volunteer_g12_first_fields,
        append: volunteer_g12_first_append,
        remove: volunteer_g12_first_remove,
        move: volunteer_g12_first_move
    } = useFieldArray({
        control,
        name: 'volunteer.g12.first',
    });
    const {
        fields: volunteer_g12_second_fields,
        append: volunteer_g12_second_append,
        remove: volunteer_g12_second_remove,
        move: volunteer_g12_second_move
    } = useFieldArray({
        control,
        name: 'volunteer.g12.second',
    });


    return (
        <div>
            <table className='table table-sm table-bordered text-center align-middle'>
                <thead>
                    <tr className='align-middle'>
                        <th rowSpan={2} colSpan={2}>Grade</th>
                        <th colSpan={4}>Activity</th>
                        {!isRead && <th rowSpan={2}></th>}
                    </tr>
                    <tr className='align-middle'>
                        <th style={{width:"100px"}}>Dates</th>
                        <th style={{width:"auto"}}>Place/the competent<br /> institutions</th>
                        <th style={{width:"auto"}}>Details</th>
                        <th style={{width:"80px"}}>Hours</th>
                    </tr>
                </thead>

                {/* g10 1st */}
                <VolunteerTbody
                    register={register}
                    grade={'g10'}
                    semester={1}
                    fields={volunteer_g10_first_fields}
                    append={volunteer_g10_first_append}
                    remove={volunteer_g10_first_remove}
                    move={volunteer_g10_first_move}
                    isRead={isRead}
                />

                {/* g10 2nd */}
                <VolunteerTbody
                    register={register}
                    grade={'g10'}
                    semester={2}
                    fields={volunteer_g10_second_fields}
                    append={volunteer_g10_second_append}
                    remove={volunteer_g10_second_remove}
                    move={volunteer_g10_second_move}
                    isRead={isRead}
                />

                {/* g11 1st */}
                <VolunteerTbody
                    register={register}
                    grade={'g11'}
                    semester={1}
                    fields={volunteer_g11_first_fields}
                    append={volunteer_g11_first_append}
                    remove={volunteer_g11_first_remove}
                    move={volunteer_g11_first_move}
                    isRead={isRead}
                />

                {/* g11 2nd */}
                <VolunteerTbody
                    register={register}
                    grade={'g11'}
                    semester={2}
                    fields={volunteer_g11_second_fields}
                    append={volunteer_g11_second_append}
                    remove={volunteer_g11_second_remove}
                    move={volunteer_g11_second_move}
                    isRead={isRead}
                />

                {/* g12 1st */}
                <VolunteerTbody
                    register={register}
                    grade={'g12'}
                    semester={1}
                    fields={volunteer_g12_first_fields}
                    append={volunteer_g12_first_append}
                    remove={volunteer_g12_first_remove}
                    move={volunteer_g12_first_move}
                    isRead={isRead}
                />

                {/* g12 2nd */}
                <VolunteerTbody
                    register={register}
                    grade={'g12'}
                    semester={2}
                    fields={volunteer_g12_second_fields}
                    append={volunteer_g12_second_append}
                    remove={volunteer_g12_second_remove}
                    move={volunteer_g12_second_move}
                    isRead={isRead}
                />
            </table>
        </div>
    )
}

export default VolunteerTable

const VolunteerTbody = ({ register, grade, semester, fields, remove, append, move, isRead }) => {
    let gradeStr = grade.toUpperCase()
    let semesterStr = semester === 1 ? '1st' : '2nd'
    let semesterKey = semester === 1 ? 'first' : 'second'
    return (
        <tbody>
            {fields.map((item, index) => {
                return (
                    <tr key={'volunteer' + item.id}>
                        {index === 0 &&
                            <>
                                <td rowSpan={fields.length}>{gradeStr}</td>
                                <td rowSpan={fields.length}>{semesterStr}</td>
                            </>
                        }
                        <td>
                            <SchoolRecordInput type='date' register={register} name={`volunteer.${grade}.${semesterKey}.${index}.date`} isRead={isRead} />
                        </td>
                        <td>
                            <SchoolRecordInput register={register} name={`volunteer.${grade}.${semesterKey}.${index}.place`} isRead={isRead} />
                        </td>
                        <td>
                            <SchoolRecordInput register={register} name={`volunteer.${grade}.${semesterKey}.${index}.detail`} isRead={isRead} />
                        </td>
                        <td>
                            <SchoolRecordInput register={register} name={`volunteer.${grade}.${semesterKey}.${index}.hour`} isRead={isRead} />
                        </td>
                        {!isRead &&
                            <td>
                                {/* ⚽순서이동 */}
                                {/* <button type="button" className="btn btn-sm btn-secondary me-1"
                                onClick={() => move(index, index - 1)}
                                disabled={index === 0}
                            >
                                ▲
                            </button>
                            <button type="button" className="btn btn-sm btn-secondary me-1"
                                onClick={() => move(index, index + 1)}
                                disabled={index === fields.length - 1}
                            >
                                ▼
                            </button> */}
                                <button type="button" className="btn btn-sm btn-outline-danger"
                                    onClick={() => remove(index)}
                                >
                                    X
                                </button>
                            </td>
                        }
                    </tr>
                )
            })}

            {!isRead &&
                <tr>
                    <td colSpan={7}>
                        <button type='button' className='btn btn-sm btn-outline-primary' onClick={() => { append({ date: '', place: '', detail: '', hour: '' }) }} >추가</button>
                    </td>
                </tr>
            }
        </tbody>
    )
}